import { COUNTRY_CODE, DECIMAL, INTEGER } from '@belimo-retrofit-portal/logic';
import * as D from 'io-ts/Decoder';
import { CarbonIntensity } from 'src/modules/carbon-intensity/types/CarbonIntensity';

export const CARBON_INTENSITY: D.Decoder<unknown, CarbonIntensity> = D.struct({
  country: COUNTRY_CODE,
  year: INTEGER,
  value: DECIMAL,
});
